import type { TypedStoreModule } from '@/types/vuex';
import {
  NAV_SET_MAIN_VIEW,
  NAV_SET_SUB_VIEW,
  NAV_SET_IS_AUTH,
} from '../action_types/nav';


export interface NavState {
  mainView: string,
  subView: string,
  isAuth: boolean,
}


const state: NavState = {
  mainView: '',
  subView: '',
  isAuth: false,
};

const getters = {
  getSubView: (state: NavState) => state.subView,
  getMainView: (state: NavState) => state.mainView,
  isAuthView: (state: NavState) => state.isAuth,
};

const mutations = {
  [NAV_SET_MAIN_VIEW]: (state: NavState, payload: string) => {
    state.mainView = payload;
  },
  [NAV_SET_SUB_VIEW]: (state: NavState, payload: string) => {
    state.subView = payload;
  },
  [NAV_SET_IS_AUTH]: (state: NavState, payload: boolean) => {
    state.isAuth = payload;
  },
};

const storeModule = {
  state,
  getters,
  mutations,
  namespaced: true,
};

export type NavModule = TypedStoreModule<'nav', typeof storeModule>;

export default storeModule;
